module.exports = __webpack_public_path__ + "low-hanging-fruit.2006220902d0cf8a1fb5efb95b6358c1.svg";